import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import shortid from 'shortid';

import WP from 'WP';
import api from 'api';
import modules from 'modules';
import { setImageGallery, setCurrentView } from 'store';

import Page from 'views/Page';
import VenueFeatures from './VenueFeatures';
import ConferenceRequestForm from './ConferenceRequestForm';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Overlay from 'partials/Overlay';
import ErrorBoundary from 'partials/ErrorBoundary';
import Footer from 'partials/Footer';

import Media from 'css/Media';

export class ConferenceVenuePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            defaultValue: null,
            disabled: false,
            loading: null,
        };
        this.formId = 'form-' + shortid.generate();
    }

    componentDidMount() {
        this.props.setCurrentView(null);
        this.preparePage();
    }

    componentDidUpdate(nextProps) {
        if(nextProps.match.params.slug != this.props.match.params.slug) {
            this.preparePage();
        }
    }

    preparePage = () => {
        const self = this;
        window.scrollTo(0, 0);
        this.setState({
            loading: true,
        }, () => {
            api.conferenceVenuesFetcher.getAll().then(() => {
                api.conferenceVenuesFetcher.getBySlug({ slug: this.props.match.params.slug }).then(r => {
                    if(!r.data.length) {
                        self.setState({
                            loading: false,
                        });
                        console.log('error fetching conference venue page by slug: ',this.props.match.params.slug)
                        return;
                    } else {
                        let page = r.data[0];
                        this.props.setCurrentView(page);
                        self.setState({
                            loading: false,
                            defaultValue: {
                                label: r.data[0].acf.title,
                                value: r.data[0].id
                            } 
                        },() => self.scrapeForImages())
                    }
                })
            })
        });
    }

    scrapeForImages() {
        let { page } = this.props;

        if(page.acf.modules) {
            let arr = [];

            let twoImagesArr = page.acf.modules.filter(module => module.acf_fc_layout === "two_images");
            if(twoImagesArr.length) {
                twoImagesArr.map(module => {
                    arr.push({image: module.image_one});
                    arr.push({image: module.image_two});
                    return null;
                })
            }

            let imageModuleArr = page.acf.modules.filter(module => module.acf_fc_layout === "image");
            if(imageModuleArr.length) {
                imageModuleArr.map(module => {
                    arr.push({image: module.image});
                    return null;
                })
            }

            this.props.setImageGallery(arr);
        }
    }

    render() {
        const { defaultValue, loading} = this.state;
        const { page } = this.props;

        // If we can't match a conference venue to the current slug
        // we use the Page view to render a normal page view instead.
        if(!page && loading === false) return <Page/>

        if(loading || !page && !loading) return null;

        const showConferenceForm = page.type === 'conference_venues';

        return (
            <Wrapper>
                <Container grid>
                    <DescriptionGridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                        rowStart={1}
                        justify="center"
                    >
                        <h1>{page.acf.title}</h1>
                        <p>{page.acf.description}</p>
                        <VenueFeatures venue={page} />
                    </DescriptionGridElement>
                </Container>
                <Modules>
                    <ErrorBoundary for="Activity Builder">
                        { page && page.acf.modules ? 
                            page.acf.modules.map((module, i) => {
                                return (
                                    <div key={i} className={'module-'+module.acf_fc_layout}>
                                        {React.createElement(modules[module.acf_fc_layout], { data: module })}
                                    </div>
                                )
                            })
                        : null}
                    </ErrorBoundary>
                </Modules>
                <Container grid>
                    <FormSectionGridElement
                        id={this.formId}
                        colStart={{default: 1, s: 5}}
                        colEnd={{default: 8, s: 20}}
                        rowStart={3}
                    >
                        <ConferenceRequestForm
                            showConferenceForm={showConferenceForm}
                            venue={page} 
                            defaultValue={defaultValue}
                        />
                    </FormSectionGridElement>
                </Container>
                <Overlay />
                <ErrorBoundary for="Footer">
                    <Footer/>
                </ErrorBoundary>
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    conference_venues: state.conference_venues.posts[WP.lang] ? state.conference_venues.posts[WP.lang] : [],
    page: state.currentView,
});

const actions = {
    setImageGallery,
    setCurrentView
};

export default connect(mapStateToProps, actions)(withRouter(ConferenceVenuePage));


const Wrapper = styled.section`
    scroll-behavior: smooth;
    width: 100%;
    padding-top: ${props => props.theme.spacing.blockS};
    
    ${ Media.greaterThan('s')`
        padding-top: 220px;
    ` }  
`

const DescriptionGridElement = styled(GridElement)`
    h1 {
        ${props => props.theme.fonts.h2};
        margin-bottom: ${props => props.theme.spacing.contentXL};
        ${ Media.greaterThan('s')`
            margin-bottom: ${props => props.theme.spacing.elementS};
        `}
    }
    p {
        font-size: 18px;
        line-height: 27px;
        margin-bottom: ${props => props.theme.spacing.elementXS};
        ${ Media.greaterThan('s')`
            ${props => props.theme.fonts.h5};
            line-height: 32px;
        `}
    }
`

const FormSectionGridElement = styled(GridElement)``

const Modules = styled.section`
    padding-bottom: ${props => props.theme.spacing.blockS};
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXL};
    `}
`